export default "__VITE_ASSET__DBpqFL6x__"